import { oc } from '@orpc/contract';
import { findContactByPhoneInputSchema, findContactByPhoneOutputSchema } from '../schemas/contacts.schemas.js';
/** The estimator's "is this customer already known?" lookup. Matching is normalised on both sides. */
export const findContactByPhoneContract = oc
    .route({
    method: 'GET',
    path: '/contacts/by-phone',
    tags: ['Contacts'],
    summary: 'Find a contact by phone number',
})
    .input(findContactByPhoneInputSchema)
    .output(findContactByPhoneOutputSchema);
//# sourceMappingURL=find-contact-by-phone.contract.js.map